import axios from 'axios';
import { API_BASE_URL } from '../constants';

export default class TaskControlsService {
	static instance;

	static getInstance() {
		if (!TaskControlsService.instance) {
			TaskControlsService.instance = new TaskControlsService();
		}

		return TaskControlsService.instance;
	}

    async fetchControls(params = {}){
        const response = await axios.get(`${API_BASE_URL}/control/index`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data || [];
    }  

    async addControl(taskId, payload){
        const response = await axios.post(
            `${API_BASE_URL}/task/${taskId}/add_control`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async removeControl(taskId, payload){
        const response = await axios.post(
            `${API_BASE_URL}/task/${taskId}/remove_control`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }
}